import React from 'react';
import moment from 'moment';
import { View } from '@coinscrap/webapp-core';
import InputLabel from 'components/InputLabel/InputLabel';




export const BirthDate = ({ birthDate, setBirthDate }) => {
	return (
		<View inputFreeRowSt>
			<InputLabel
				style={{ marginTop: -20 }}
				value={birthDate}
				onChange={(e) => {
					setBirthDate(e);
				}}
				placeholder="dd/mm/yyyy"
				label={'Fecha de nacimiento'}
				type="date"
				errorMsg={
					(moment(birthDate).unix() > moment().subtract(18, 'years').unix() &&
						'La edad mínima de contratación es de 18 años') ||
					(moment(birthDate).unix() < moment().subtract(67, 'years').unix() &&
						'La edad máxima de contratación es de 67 años')
				}
			/>
		</View>
	);
};
